import { createFileRoute, redirect } from "@tanstack/react-router";

/** Kept so old links still land. Insurance is a section of the Profile tab, as on the live
 * chart. */
export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/insurance")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/residents/$residentId", params });
  },
});
